import React, { useState } from 'react';
import { Form, Input, message, Button } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { Navigate } from 'react-router-dom';
import { auth } from '../../../firestoreConfig';
import { signInWithEmailAndPassword } from "firebase/auth";

import global from '../../../shared/utility/global';
import Loading from '../../../shared/components/Loading/Index';
import security from '../../../assets/images/security.svg';

import './styles.css';

export default function Index(_) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onSubmit = async () => {
        var values = {};
        var validations = await form.validateFields().then((_values) => values = _values).catch(() => false);
        if (!validations) {
            message.warning('Complete los datos del formulario.', 5);
            return;
        }

        setLoading(true);

        await signInWithEmailAndPassword(auth, values.userName, values.password)
            .then(result => {

            })
            .catch(error => {
                console.log(error);
                message.error('Usuario o contraseña incorrecto(s).', 5);
            });
        setLoading(false);
    };

    if (auth.currentUser) {
        return (<Navigate to='/' />);
    }

    return (
        <div id="core-components-login">
            <div className="content-main">
                <div className="content-border">
                    <Loading visible={loading} size="xxx-large" height='100%'>
                        <div className="vertical-center">
                            <div className="text-center" style={{ width: '100%', zIndex: '1' }}>
                            <img src={security} style={{ width: 50 }} alt="img" />
                                <div>
                                    <span className="project-text">JM Cartem</span>
                                </div>
                                <Form form={form} name="login-form" className="mt-15" onFinish={onSubmit}>
                                    <Form.Item className="input-login" name="userName" rules={[{ required: true, message: '' }]}>
                                        <Input
                                            prefix={<UserOutlined style={{ color: '#157137' }} />}
                                            placeholder="Usuario"
                                            autoComplete="off"
                                        />
                                    </Form.Item>
                                    <Form.Item className="input-login" name="password" rules={[{ required: true, message: '' }]}>
                                        <Input.Password
                                            prefix={<LockOutlined style={{ color: '#157137' }} />}
                                            autoComplete="off"
                                            placeholder="Contraseña"
                                        />
                                    </Form.Item>

                                    <div className="mt-15">
                                        <Button type="primary" htmlType="submit">Ingresar</Button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                        <div className="footer">© {process.env.REACT_APP_companyName}. Todos los derechos reservados {global.fetchCurrentYear()}</div>
                    </Loading>
                </div>
            </div>
        </div>
    );
}